export default __webpack_public_path__ + "static/media/officeBookcase.94268747.jpg";